/**
 * @file
 */

export default (Drupal, once) => {

  // ! Main menu and mobile icon
  Drupal.behaviors.mainNavigation = {
    attach (context) {
      once('main-navigation', '.site-header', context).forEach(function () {

        // expand animation function
        function autoHeightAnimate(element, time) {
          const curHeight = element.offsetHeight; // Get Default Height
          element.style.height = 'auto';
          const autoHeight = element.offsetHeight; // Get Auto Height
          element.style.height = curHeight + 'px'; // Reset to Default Height
          setTimeout(() => {
            element.style.transition = `height ${time}ms`;
            element.style.height = autoHeight + 'px';
          }, 100);

          element.addEventListener('transitionend', function handler() {
            element.style.height = 'auto'; // Reset to Auto Height after animation
            element.style.transition = '';
            element.removeEventListener('transitionend', handler);
          });
        }

        function autoHeightAnimateClose(element, time, height) {
          const curHeight = element.offsetHeight; // Get Default Height
          element.style.height = curHeight + 'px'; // Set to Default Height
          setTimeout(() => {
            element.style.transition = `height ${time}ms`;
            element.style.height = `${height}px`;
          }, 100);

          element.addEventListener('transitionend', function handler() {
            element.style.height = ''; // Reset height after animation
            element.style.transition = '';
            element.removeEventListener('transitionend', handler);
          });
        }

        // ! Menu - toggle mobile menu.
        const menuContainer = document.querySelector('.site-header')
        const mobileMenuButton = document.getElementById('mobile-menu-button')

        mobileMenuButton.addEventListener('click', function (e) {
          e.preventDefault()

          if (menuContainer.classList.contains('mobile-menu-open')) {
            // If open, close menu
            menuContainer.classList.remove('mobile-menu-open')
            mobileMenuButton.setAttribute('aria-expanded', false)
            autoHeightAnimateClose(menuContainer, 200, 88)
          } else {
            // If closed, open menu
            mobileMenuButton.setAttribute('aria-expanded', true)
            menuContainer.classList.add('mobile-menu-open')
            autoHeightAnimate(menuContainer, 200)
          }
        })

        // ! Menu - drop-down menu.
        const mainMenu = '.menu--main > .menu > .menu-item--expanded'
        const secondaryMenu = '.menu--secondary-menu > .menu > .menu-item--expanded'
        const menuExpanded = document.querySelectorAll(mainMenu + ', ' + secondaryMenu)

        // Convert anchor to button
        function convertAnchorToButton(anchor) {
          const newButton = document.createElement('button')
          const convertText = anchor.textContent.replace(/\s+/g, '-').toLowerCase()
          newButton.textContent = anchor.textContent
          newButton.innerHTML += '<span><i></i><i></i></span>'
          newButton.classList.add('toggle-dropdown')
          newButton.setAttribute('id', convertText)
          newButton.setAttribute('aria-expanded', false)
          anchor.replaceWith(newButton)

          return newButton
        }

        // Handle click event
        function handleToggleButtonClick(event) {
          event.preventDefault()
          const button = event.currentTarget
          const menuItemExpanded = button.parentNode

          if (menuItemExpanded.classList.contains('menu-open')) {
            button.setAttribute('aria-expanded', false)
            menuItemExpanded.classList.add('fade-out')
            menuItemExpanded.classList.remove('menu-open')
            setTimeout(function () {
              menuItemExpanded.classList.remove('fade-out')
            }, 500)
          } else {
            menuExpanded.forEach(item => {
              item.classList.remove('menu-open')
              item.querySelectorAll('.toggle-dropdown').forEach(toggleButton => {
                toggleButton.setAttribute('aria-expanded', false)
              })
            })
            menuItemExpanded.classList.add('fade-in')
            button.setAttribute('aria-expanded', true)
            setTimeout(() => {
              menuItemExpanded.classList.add('menu-open')
            }, 0)
            setTimeout(() => {
              menuItemExpanded.classList.remove('fade-in')
            }, 100)
          }
        }

        // Add event listener for each menu item
        menuExpanded.forEach(menuItem => {
          const anchor = menuItem.querySelector('a[href^="#"]')
          if (anchor) {
            const button = convertAnchorToButton(anchor)
            button.addEventListener('click', handleToggleButtonClick)
          }
        })

        // Handle click outside
        function handleClickOutside(event) {
          if (window.innerWidth > 992) {
            menuExpanded.forEach(menuItem => {
              if (!menuItem.contains(event.target)) {
                menuItem.classList.remove('menu-open')
                if (menuItem.classList.contains('menu-open')) {
                  menuItem.classList.add('fade-out')
                  setTimeout(function () {
                    menuItem.classList.remove('fade-out')
                  }, 500)
                }
                menuItem.querySelectorAll('.toggle-dropdown').forEach(toggleButton => {
                  toggleButton.setAttribute('aria-expanded', false)
                })
              }
            })
          }
        }

        // Handle escape key
        function handleEscKey(event) {
          if (event.key === 'Escape') {
            menuExpanded.forEach(menuItem => {
              menuItem.classList.remove('menu-open')
              if (menuItem.classList.contains('menu-open')) {
                menuItem.classList.add('fade-out')
                setTimeout(function () {
                  menuItem.classList.remove('fade-out')
                }, 500)
              }
              menuItem.querySelectorAll('.toggle-dropdown').forEach(toggleButton => {
                toggleButton.setAttribute('aria-expanded', false)
              })
            })
          }
        }

        document.addEventListener('click', handleClickOutside)
        document.addEventListener('keydown', handleEscKey)

      })
    }
  }
}
